import styled from 'styled-components';

import MRAditionalOptions from 'components/summary/MRAditionalOptions/container';

export default styled(MRAditionalOptions)`
  & > div {
    margin-top: 14px;
    margin-bottom: 14px;

    .payload {
      width: 90%;
      & > div {
        width: 100%;
      }
    }
  }
`;
